import { FormFieldTypes } from "../../../data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";


export const ManualAccountTaskList = {
    name: "ManualAccountTaskList",
    initialState: {
        name: '',
        gmpTier: '',
        gmpNumber: '',
        flagId: '',
    },
    formFields: [
        {
            id: "name",
            lable: "Search by Name/Email",
            Field_Name: " Search by Name/Email",
            fieldType: FormFieldTypes.INPUT,
            dataField: "name",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            style: {
                containerCss: "col-lg-6 mb-3"
            }
        },

        {
            id: "gmpTier",
            lable: "GMP Tier",
            Field_Name: "GMP Tier",
            fieldType: FormFieldTypes.SELECT,
            dataField: "gmpTier",
            fieldSetting: {
                placeholder: " ",
                options: []
            },
            style: {
                containerCss: "col-lg-6 mb-3"
            }
        },

        {
            id: "gmpNumber",
            lable: "GMP Number",
            Field_Name: "GMP Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "gmpNumber",
            fieldSetting: {
                placeholder: " ",
                options: []
            },
            style: {
                containerCss: "col-lg-6 mb-3"
            }
        },

        {
            id: "flagId",
            lable: "Flag",
            Field_Name: "Flag",
            fieldType: FormFieldTypes.SELECT,
            dataField: "flagId",
            fieldSetting: {
                placeholder: " ",
                options: []
            },
            style: {
                containerCss: "col-lg-6 mb-3"
            }
        },

    ],
    formSetting: {
        isViewOnly: false
    }
}

export const ManualAccountTaskListConfig = {
    columns: [

        {
            name: "Create Date",
            fieldName: "createdDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
        {
            name: "Name",
            fieldName: "fullName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Email Address",
            fieldName: "primaryEmail",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "GMP Tier",
            fieldName: "gmpTier",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "GMP Number",
            fieldName: "gmapNumber",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "GMP Course",
            fieldName: "isGmpCourse",
            allowShort: false,
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: false
            },
        },
        {
            name: "Appeal",
            fieldName: "isAppeal",
            allowShort: false,
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: false
            },
        },
        {
            name: "Transitioning",
            fieldName: "isTransitioning",
            allowShort: false,
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: false
            },
        },
        {
            name: "Distinguished",
            fieldName: "isDistinguished",
            allowShort: false,
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: false
            },
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true,
            },
        },
    ],
};

